<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'Resume' | translate }}</h5>
    <button type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    </form>
  </div>
</div>
